import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Container,
  CardHeader,
  Table,
  Row,
  Button,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from 'reactstrap';
import Pagination from 'components/Pagination';
import SimpleHeader from 'components/Headers/SimpleHeader';
import webhookService from 'views/CRM/Webhook/services/webhookService';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

function WebhookList() {
  const [webHook, setWebHook] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [search, setSearch] = useState('');
  const [count, setCount] = useState(10);
  const history = useHistory();

  const disabledWebHook = (id, ip_origem, host, IsEnable) => {
    webhookService
      .changeStatus(id)
      .then(() => {
        toast.success(
          `Webhook ${ip_origem ? ip_origem : ''}${
          ip_origem && host ? ', ' : ''
          }${host ? host : ''} ${!IsEnable ? 'habilitado' : 'desabilitado'}`
        );
        getWebhook();
      })
      .catch(() => {
        toast.error(
          `Erro ao ${!IsEnable ? 'Desabilitar' : 'Habilitar'} Webhook`
        );
      });
  };

  const getWebhook = (newPage, name) => {
    return webhookService
      .getWithPagination({
        page: newPage || activePage,
        name
      })
      .then((response) => {
        setWebHook(response.data.data);
        setCount(
          response.data.data.length < 10 && newPage === 1
            ? response.data.data.length
            : response.data.count
        );
      });
  };

  useEffect(() => {
    getWebhook(1, search);
    setActivePage(1);
  }, [search]);

  const goToPage = (newPage) => {
    setActivePage(newPage);
    getWebhook(newPage, search);
  };

  const handleEditClick = (item) => {
    history.push({
      pathname: '/admin/crm/webhooks/form',
      state: { webhook: item }
    });
  };

  return (
    <>
      <SimpleHeader
        setCreate={`/admin/crm/webhooks/form`}
        name="Form"
        parentName="Forms"
        returnPath="/admin/configuration"
        showBackArrow="yes"
      ></SimpleHeader>
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">WebHooks</h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Buscar WebHook pelo Nome"
                        value={search}
                        type="text"
                        defaultValue=""
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <CardBody>
                  <Table hover={true} striped>
                    <thead>
                      <tr>
                        <th className="text-center">Nome</th>
                        <th className="text-center">Link</th>
                        <th className="text-center">Entidade</th>
                        <th className="text-center">Desabilitar/Habilitar</th>
                        <th className="text-center">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {webHook.length > 0 ? (
                        webHook.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center">{item.name}</td>
                            <td className="text-center">
                              <span
                                onClick={() => {
                                  window.open(item.webHookLink, '_blank');
                                }}
                              >
                                {item.webHookLink}
                              </span>
                            </td>
                            <td className="text-center">{item.entity}</td>
                            <td className="text-center">
                              <ToggleSwitch
                                checked={item.isEnable}
                                id={item.id}
                                onChange={() =>
                                  disabledWebHook(
                                    item.id,
                                    item.ip_origem,
                                    item.host,
                                    item.isEnable
                                  )
                                }
                              />
                            </td>
                            <td className="text-center">
                              <Button
                                color="info"
                                size="sm"
                                disabled={false}
                                onClick={() => handleEditClick(item)}
                              >
                                <li className="fas fa-edit"></li>
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              Nenhum webhook encontrado
                          </td>
                          </tr>
                        )}
                    </tbody>
                  </Table>
                </CardBody>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={count}
                  onChange={goToPage.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default WebhookList;
